module.exports = __webpack_public_path__ + "static/media/logo.17f6f491.svg";